













































import { api } from "@/api/api";
import { ApiGetGrantRateDto } from "@/api/generated/Api";
import TrainingGrantsModal from "@/components/administration/training-grants/TrainingGrantsModal.vue";
import BaseModal from "@/components/shared/BaseModal.vue";
import BaseTooltipIconButton from "@/components/shared/button/BaseTooltipIconButton.vue";
import BaseTableFiltered from "@/components/shared/table/BaseTableFiltered.vue";
import { getInitialModalData, useOpenModal } from "@/fragments/modal/useOpenModal";
import { ModalType } from "@/shared/enums/modalTypeEnum";
import { NotificationItemType } from "@/shared/enums/notificationItemEnum";
import { formatDateShort } from "@/shared/helpers/dateHelpers";
import { globalLoadingWrapper } from "@/shared/helpers/loadingHelpers";
import { openNotification } from "@/shared/helpers/store.helpers";
import { ModalBaseData } from "@/shared/interfaces/ModalBaseData.interface";
import { useStore } from "@/shared/useHelpers";
import { StoreState } from "@/store/store.state.interface";
import { defineComponent, onMounted, ref } from "@vue/composition-api";
import { getYear } from "date-fns";

export default defineComponent({
  name: "TrainingGrantsPage",
  components: {
    BaseTooltipIconButton,
    BaseTableFiltered,
    BaseModal,
    TrainingGrantsModal,
  },
  setup() {
    const store = useStore<StoreState>();
    const trainingGrants = ref<ApiGetGrantRateDto[]>();
    const modalData = ref(getInitialModalData());
    const search = ref("");
    const currentYear = getYear(new Date());

    const openAddGrant = useOpenModal(ModalType.Add, "", modalData);
    const openEditGrant = useOpenModal(ModalType.Edit, "", modalData);
    const openDisplayGrant = useOpenModal(ModalType.Display, "", modalData);
    const closeModal = (modalData: ModalBaseData) => {
      modalData.showModal = false;
      getTrainingGrants();
    };

    const getTrainingGrants = () => {
      globalLoadingWrapper({ blocking: true }, async () => {
        trainingGrants.value = (await api.economy.getGrantRates()).data;
      });
    };

    const addTrainingGrant = () => {
      if (!trainingGrants.value) {
        return;
      }
      const isExisitinGrant = trainingGrants.value.find((grant) => grant.year === currentYear);
      if (!isExisitinGrant) {
        openAddGrant();
      } else {
        openNotification(
          store,
          NotificationItemType.Information,
          `Det kan ikke opprettes flere tilskudd for ${getYear(Date.now()).toString()}.`
        );
        openEditGrant(isExisitinGrant);
      }
    };

    onMounted(async () => await getTrainingGrants());

    return {
      trainingGrants,
      modalData,
      headers,
      search,
      addTrainingGrant,
      openEditGrant,
      openDisplayGrant,
      closeModal,
      formatDateShort,
    };
  },
});

const headers = [
  { text: "År", value: "year" },
  { text: "Opplæringstilskudd", value: "teachingGrantAmount" },
  { text: "Ekstra Faglige kurs", value: "extraProfessionalCourseAmount" },
  { text: "Versjon", value: "version" },
  { text: "Oppdatert av", value: "updatedByUserFullName" },
  { text: "Oppdatert når", value: "updated" },
  { text: "Handlinger", value: "actions" },
];
